import './autosize.js';

export const initTextarea = function() {
  const textResize = document.querySelectorAll('[data-text-resize]');
  if (textResize.length > 0) {
    textResize.forEach((element) => {
      autosize(element);
    });
  }
}
